import { AsyncPipe } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { LayoutComponent } from 'app/layout/layout.component';
import { NotificationService } from 'app/services/notification.service';
import { liveQuery } from 'dexie';
import { appDb } from 'dexie/app.db';
import { from, Subscription } from 'rxjs';

@Component({
  selector: 'app-admin-layout',
  imports: [LayoutComponent, AsyncPipe],
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.scss',
})
export class AdminLayoutComponent implements OnInit, OnDestroy {
  protected notificationService = inject(NotificationService);
  cacheKeys$ = from(liveQuery(() => appDb.cacheKeys.toArray()));
  subs = new Subscription();
  ngOnInit(): void {
    this.notificationService.requestNotifications();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
